export const ROWS_PER_PAGE = 50;
